<template>
    <center-container>
        <v-textarea
            v-model="answer"
            autofocus
            flat
            outlined
            hide-details
        ></v-textarea>

        <skip-and-send-button
            @send="sendAnswer"
            @skip="$emit('skip')"
            :disabled="! answer"
        />
    </center-container>
</template>

<script>
import CenterContainer from './CenterContainer.vue'
import SkipAndSendButton from './SkipAndSendButton.vue'

export default {
    components: {
        CenterContainer,
        SkipAndSendButton,
    },

    data: () => ({
        answer: null
    }),

    methods: {
        sendAnswer() {
            this.$emit('input', this.answer)
        }
    }
}
</script>
